// src/data/loc-data.ts
export interface LocationData {
  name: string;                // e.g., "Sydney Studio"
  addressHTML: string;         // allows <br> for line breaks
  imgURL: string;              // hero/cover image for the location
  mapURL: string;              // Google Maps share URL
  email?: string;
  phone?: string;
  imgLoaded: boolean;
}

export const locationDataArray: Array<LocationData> = [
  {
    name: 'The Vault Studios',
    addressHTML: 'Suite 4, 37 Nicholson St<br>Balmain East NSW 2041<br>Australia',
    imgURL: 'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/team%2Fwaterview1.jpeg?alt=media',
    mapURL: 'https://maps.app.goo.gl/HbkL8QpD89a3QhwM7',
    email: 'producer@uncannyvalley.com.au',
    phone: '+61 (0)400439355',
    imgLoaded: false
  }
  // {
  //   name: 'Miami',
  //   addressHTML: '200 Example Ave<br>Miami, FL 33130<br>USA',
  //   imgURL: 'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/locations%2Fmiami.jpg?alt=media',
  //   mapURL: 'https://maps.google.com/?q=Miami+FL+33130',
  //   email: 'hello@uncannyvalley.com.au',
  //   phone: '+1 (305) 000-0000',
  //   imgLoaded: false
  // }
];

/** An image with a crop anchor for object-fit: cover (CSS object-position,
 *  e.g. '85% 50%' to keep a right-of-centre subject in frame). A string
 *  applies everywhere; { desktop, mobile } sets each layout separately. */
export interface GalleryImage {
  src: string;
  position?: string | { desktop: string; mobile: string };
}

/** A gallery item is an image URL, an image with a crop anchor, or a video
 *  with an optional poster. */
export interface GalleryVideo {
  type: 'video';
  src: string;
  poster?: string;
  /** Time (s) the poster was taken from; the first play starts here so the
   *  video fades in over a matching frame instead of a fade-from-black. */
  posterTime?: number;
  /** Portrait encode used instead of src/poster in the mobile layout. */
  portrait?: {
    src: string;
    poster?: string;
  };
}
export type GalleryItem = string | GalleryImage | GalleryVideo;

export function isGalleryVideo(item: GalleryItem): item is GalleryVideo {
  return typeof item !== 'string' && 'type' in item && item.type === 'video';
}

export function galleryImageSrc(item: string | GalleryImage): string {
  return typeof item === 'string' ? item : item.src;
}

export function galleryImagePosition(item: string | GalleryImage, mobileLayout: boolean): string | undefined {
  if (typeof item === 'string' || item.position === undefined) { return undefined }
  if (typeof item.position === 'string') { return item.position }
  return mobileLayout ? item.position.mobile : item.position.desktop
}

// Gallery items for the location view. The first item is a looping video
// that fades through black at its loop point.
export const locationGalleryItems: Array<GalleryItem> = [
  {
    type: 'video',
    src: 'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/studio-carousel%2Fstudio-loop-fade-20s.mp4?alt=media&token=82402412-419b-4ad4-8141-82bb7bedb6ee',
    poster: 'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/studio-carousel%2Fstudio-loop-fade-20s-poster.jpg?alt=media&token=f56cad0b-b081-4c79-a5c7-95f21f0451e5',
    posterTime: 1.0,
    portrait: {
      src: 'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/studio-carousel%2Fstudio-loop-portrait-fixed-20s.mp4?alt=media&token=4cb6edee-3091-4df7-a6d8-379784a8988b',
      poster: 'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/studio-carousel%2Fstudio-loop-portrait-fixed-20s-poster.jpg?alt=media&token=ead25d20-da57-47af-bde8-9b3d02f52884'
    }
  },
  {
    // Wide wharf shot; the frontage sits right of centre
    src: 'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/studio-carousel%2FWWW_1.jpg?alt=media&token=8a6fd265-8da6-42cc-9a75-81bd565bd4dd',
    position: '85% 50%'
  },
  // Add more gallery images here
  {
    // Vault door sits on the right of the frame
    src: 'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/studio-carousel%2Fthe-vault-04.jpg?alt=media&token=91ae030e-7dc2-41d6-b584-03822f46e020',
    position: { desktop: '100% 50%', mobile: '85% 50%' }
  },
  'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/studio-carousel%2Fstudio-a-final.jpg?alt=media&token=7a28643b-8e86-47b5-b5f0-87641f8adae6',
  'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/studio-carousel%2Fstudio-b-final.jpg?alt=media&token=f7b9a89c-f922-476d-bbb3-b6d37e49a864',
  'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/studio-carousel%2Fstudio-c-final.jpg?alt=media&token=c29e096d-f983-4d6f-ae72-87efe2c39c41',
];